import { focusManager, QueryClient } from "@tanstack/react-query";

// TanStack's default browser listener covers visibility changes. Also recheck
// policy when returning to a still-visible window (for example, another app).
focusManager.setEventListener((onFocus) => {
  if (typeof window === "undefined") return;
  const listener = () => onFocus();
  window.addEventListener("focus", listener);
  window.addEventListener("visibilitychange", listener);
  return () => {
    window.removeEventListener("focus", listener);
    window.removeEventListener("visibilitychange", listener);
  };
});

export const queryClient = new QueryClient({
  defaultOptions: {
    // Errors here are final answers from the server (signed out, room not
    // found, room full, …), and the room directory has its own event stream.
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});
